import {createFileRoute, redirect} from '@tanstack/react-router';
import EncounterList from '@/patient/views/EncounterList';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

export const Route = createFileRoute('/(patient)/encounters')({
  component: EncounterList,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.isPatient && context.company?.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
